interface ValidCepEntity {
  isValid: boolean;
  data: any;
}

export const validCep = async (cep: string): Promise<ValidCepEntity> => {
  return fetch(`https://viacep.com.br/ws/${cep}/json/`)
    .then((resp) => resp.json())
    .then((data) => {
      if (data.erro) return { isValid: false, data: null };
      return { isValid: true, data: null };
    })
    .catch(() => ({ isValid: false, data: null }));
};
